import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Fade from '@mui/material/Fade'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import TrapFocus from '@mui/material/Unstable_TrapFocus'
import CookiesIcon from './../../assets/icons/Cookies.svg?react'

export const CookiesDialog = ({ open, handleClose }) => {
    return (
        <TrapFocus open disableAutoFocus disableEnforceFocus>
            <Fade appear={false} in={open}>
                <Paper
                    role="dialog"
                    aria-modal="false"
                    aria-label="Cookie banner"
                    square
                    variant="outlined"
                    tabIndex={-1}
                    sx={{
                        zIndex: '1201',
                        borderRadius: '24px',
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        m: 2,
                        p: 2,
                        borderWidth: 0,
                        background: '#2E3038',
                    }}>
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        sx={{ justifyContent: 'space-between', gap: 2 }}>
                        <Box sx={{ flexShrink: 1, alignSelf: { xs: 'flex-start', sm: 'center' } }}>
                            <Stack direction="row" sx={{ alignItems: 'center' }} spacing={2}>
                                <Stack
                                    sx={{
                                        background: '#40444F',
                                        minWidth: '40px',
                                        height: '40px',
                                        borderRadius: '100px',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                    <CookiesIcon />
                                </Stack>
                                <Box>
                                    <Typography sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                                        Пользуясь нашим сервисом, вы соглашаетесь с тем, что{' '}
                                        <span
                                            style={{
                                                color: '#D0F862',
                                                textDecoration: 'underline',
                                            }}>
                                            мы используем cookies
                                        </span>
                                        , чтобы постоянно повышать качество ARHIASSISTANT
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#BDBFC7' }}>
                                        Вы можете запретить использование cookie–файлов в настройках
                                        браузера
                                    </Typography>
                                </Box>
                            </Stack>
                        </Box>
                        <Stack
                            direction={{
                                xs: 'row-reverse',
                                sm: 'row',
                            }}
                            sx={{
                                gap: 2,
                                flexShrink: 0,
                                alignSelf: { xs: 'auto', sm: 'center' },
                            }}>
                            <Button fullWidth onClick={handleClose} variant="contained">
                                Принять
                            </Button>
                        </Stack>
                    </Stack>
                </Paper>
            </Fade>
        </TrapFocus>
    )
}
